(function() {
    'use strict';

    angular.module('order')
        .controller('FileImagePreviewController', FileImagePreviewController);

    FileImagePreviewController.$inject = ['$uibModalInstance', 'fileImage'];

    function FileImagePreviewController($uibModalInstance, fileImage) {
        var self = this;
        console.log("IMG", fileImage);

        self.fileImage = fileImage;
        self.ok = ok;

        function ok() {
            self.fileImage = null;
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
